// extracted by mini-css-extract-plugin
export default {"container":"touristsFormHeader-module__container__ksQNn","mobileContainer":"touristsFormHeader-module__mobileContainer__N5RsW","text":"touristsFormHeader-module__text__8nN9f"};